export const REMOVE_CUSTOMERS_ATTACHMENT_REQUEST = 'REMOVE_CUSTOMERS_ATTACHMENT_REQUEST';
export const REMOVE_CUSTOMERS_ATTACHMENT_SUCCESS = 'REMOVE_CUSTOMERS_ATTACHMENT_SUCCESS';
export const REMOVE_CUSTOMERS_ATTACHMENT_FAILURE = 'REMOVE_CUSTOMERS_ATTACHMENT_FAILURE';
